<template>
  <div class="columns is-multiline is-centered">
    <div class="column is-12">
      <div class="has-text-centered">
        No hay información
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/mixins/formats'

export default {
  name: 'Configuration',
  mixins: [mixins],
  mounted () {
    this.$emit('update-title-action', {
      label: '',
      visible: false,
      disabled: false,
      handler: this.openCreateModal
    })
  },
  methods: {
    openCreateModal () {}
  }
}
</script>
